import { Component } from '@angular/core';

@Component({
  selector: 'app-ngb-pagination-demo',
  templateUrl: './pagination-demo.component.html',
})
export class NgbPaginationDemoComponent {
  page = 4;
}
